export const getAboutSectionData = state => state?.aboutSections?.data || null
